import { render, staticRenderFns } from "./qualification.vue?vue&type=template&id=b3096146&scoped=true"
import script from "./qualification.vue?vue&type=script&lang=js"
export * from "./qualification.vue?vue&type=script&lang=js"
import style0 from "./qualification.vue?vue&type=style&index=0&id=b3096146&prod&lang=scss"
import style1 from "./qualification.vue?vue&type=style&index=1&id=b3096146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3096146",
  null
  
)

export default component.exports